export default "__VITE_ASSET__B2gRUc4g__"